import {useEffect, useState} from 'react'
import Loader from 'app/custom/loader/Loader'
import StudentFeeStatistic from './StudentFeeStatistic'
import StudentTransportStatistic from './StudentTransportStatistic'
import StudentBookStatistic from './StudentBookStatistic'
import StudentUniformStatistic from './StudentUniformStatistic'

const SchoolStudentDashboard: React.FC = () => {
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    setLoader(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (loader) return <Loader />
  return (
    <>
      <div className='row mb-4'>
        <div className='col-6'>
          <StudentFeeStatistic />
        </div>
        <div className='col-6'>
          <StudentTransportStatistic />
        </div>
      </div>

      <div className='row mb-4'>
        <div className='col-6'>
          <StudentBookStatistic />
        </div>
        <div className='col-6'>
          <StudentUniformStatistic />
        </div>
      </div>
    </>
  )
}

export default SchoolStudentDashboard
